const ORDER_STATUS = {
  OK: 'OK',
  OVERLOAD: 'OVERLOAD',
  WORK_SHIFT_TIME_NOT_EXIST: 'WORK_SHIFT_TIME_NOT_EXIST',
  LOADING_AFTER_WORK_SHIFT: 'LOADING_AFTER_WORK_SHIFT',
  LOADING_BEFORE_WORK_SHIFT: 'LOADING_BEFORE_WORK_SHIFT',
  DELIVERY_AFTER_WORK_SHIFT: 'DELIVERY_AFTER_WORK_SHIFT',
  DELIVERY_BEFORE_WORK_SHIFT: 'DELIVERY_BEFORE_WORK_SHIFT',
  ARRIVAL_TIME_NOT_EXIST: 'ARRIVAL_TIME_NOT_EXIST',
  LATE_ARRIVAL: 'LATE_ARRIVAL',
  EARLIER_ARRIVAL: 'EARLIER_ARRIVAL',
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  IS_NOT_IN_TIME: 'IS_NOT_IN_TIME',
  SCHEDULE_VIOLATIONS: 'SCHEDULE_VIOLATIONS',
};

export default ORDER_STATUS;
